import {
  CategoryTextSortDto,
  ImporterDto,
  MenuDto,
  NewsDto, ResourceListOfFaqDto,
  ResourceListOfFlagDto,
  ResourceListOfGroupDto, ResourceListOfLanguageCnrDto,
  ResourceListOfNewsDto,
  ResourceListOfPrivilegeDto,
  ResourceListOfProMTGroupDto,
  ResourceListOfRoleDto,
  ResourceListOfSpecConfigurationDto,
  ResourceListOfUserDto,
  SpecDto,
} from 'src/services/Client';
import { IReduxState } from '../IReduxState';

export const selectAdminArealinks = (state: IReduxState): MenuDto | undefined =>
  state.administration.adminAreaLinks;

export const selectUsers = (
  state: IReduxState
): ResourceListOfUserDto | undefined => state.administration.users;

export const selectGroups = (
  state: IReduxState
): ResourceListOfGroupDto | undefined => state.administration.groups;

export const selectProMTGroups = (
  state: IReduxState
): ResourceListOfProMTGroupDto => state.administration.proMTGroups;

export const selectRoles = (
  state: IReduxState
): ResourceListOfRoleDto | undefined => state.administration.roles;

export const selectPrivileges = (
  state: IReduxState
): ResourceListOfPrivilegeDto | undefined => state.administration.privileges;

export const selectFlags = (state: IReduxState): ResourceListOfFlagDto =>
  state.administration.flags;

export const selectNews = (state: IReduxState): ResourceListOfNewsDto =>
  state.administration.news;

export const selectActiveNews = (state: IReduxState): NewsDto[] | undefined =>
  state.administration.activeNews;

export const selectFaqs = (state: IReduxState): ResourceListOfFaqDto =>
    state.administration.faqs;

export const selectModelyearCategories = (
  state: IReduxState
): CategoryTextSortDto[] => state.administration.modelyearCategories;

export const selectImporterList = (
  state: IReduxState
): ImporterDto[] | undefined => state.administration.importerList;

export const selectImporter = (state: IReduxState): ImporterDto | undefined =>
  state.administration.importer;

export const selectSpecs = (state: IReduxState): SpecDto[] | undefined =>
  state.administration.specs;

export const selectDefaultImporter = (state: IReduxState): string =>
  state.administration.defaultImporter;

export const selectSpecConfigs = (
  state: IReduxState
): ResourceListOfSpecConfigurationDto | undefined =>
  state.administration.specConfigs;

export const selectActiveIndex = (state: IReduxState): number =>
  state.administration.accessTabAndFilter.activeIndex;

export const selectAccessFilter = (state: IReduxState): string | undefined =>
  state.administration.accessTabAndFilter.filter;

export const selectCnrLanguages = (
    state: IReduxState
): ResourceListOfLanguageCnrDto => state.administration.cnrLanguages;



// WEBPACK FOOTER //
// ./src/redux/selectors/administrationSelectors.ts